<template>
  <a
    class="el-button el-button--primary el-button--mini"
    :class="'is-disabled'"
    style="display: inline-block; width: 100%; text-align: center"
  >……</a>
</template>

<script>
export default {
  name: 'SeMbl2BillingOfLadingRecord',
  props: {
    disabled: { type: Boolean, default: false }
  }
}
</script>
